import type { TranslationModule } from '../types';

export const contactTranslations: TranslationModule = {
  ro: {
    seoTitle: "Contact - Legea Aplicată | Suport Tehnic & Parteneriate",
    seoDesc: "Contactează echipa Legea Aplicată pentru suport tehnic, solicitări legate de cont sau parteneriate. Suntem aici să îți oferim asistență tehnică.",
    pageTitle: "Să intrăm în legătură",
    pageSubtitle: "Ai o întrebare legată de platformă sau funcționalități? Echipa noastră de suport este pregătită să îți ofere ajutorul necesar.",
    talkToUs: "Discută cu noi",
    workingHours: "Luni - Vineri, 09:00 - 18:00",
    connectTitle: "Conectează-te",
    quickSupportTitle: "Suport Rapid",
    quickSupportDesc: "Pentru urgențe tehnice, folosește linia directă.",
    callNow: "Sună Acum",
    formTitle: "Trimite un mesaj",
    privacyNote: "Vă rugăm să ne scrieți doar după ce consultați",
    privacyLink: "politica de confidențialitate",
    labelName: "Nume Complet *",
    labelEmail: "Email *",
    labelPhone: "Telefon *",
    labelSubject: "Subiect *",
    labelMessage: "Mesaj *",
    placeholderName: "Ion Popescu",
    placeholderEmail: "ion@exemplu.ro",
    placeholderMessage: "Detaliați solicitarea dvs. aici...",
    subjectPlaceholder: "Alege un subiect...",
    subjectConsultanta: "Întrebări despre Platformă",
    subjectTehnic: "Suport Tehnic App",
    subjectParteneriat: "Parteneriate B2B",
    subjectEveniment: "Înregistrare Eveniment",
    subjectAnonimizare: "Anonimizare Document",
    subjectAltele: "Altele",
    sending: "Se trimite...",
    sendBtn: "Trimite Mesajul",
    successTitle: "Mesaj Trimis!",
    successDesc: "Mulțumim pentru contact. Echipa noastră a primit mesajul tău și va reveni cu un răspuns în cel mai scurt timp posibil.",
    sendAnother: "Trimite alt mesaj",
    errorFields: "Te rugăm să completezi următoarele câmpuri obligatorii:",
    errorCaptcha: "Te rugăm să validezi că nu ești robot.",
    errorGeneric: "A apărut o eroare. Te rugăm să încerci din nou.",
    errorSend: "Eroare la trimiterea mesajului.",
    fieldName: "Nume Complet",
    fieldEmail: "Email",
    fieldPhone: "Telefon",
    fieldSubject: "Subiect",
    fieldMessage: "Mesaj"
  },
  en: {
    seoTitle: "Contact - Legea Aplicată | Technical Support & Partnerships",
    seoDesc: "Contact the Legea Aplicată team for technical support, account inquiries, or partnerships.",
    pageTitle: "Let's Get in Touch",
    pageSubtitle: "Do you have questions about the platform or features? Our support team is ready to assist you.",
    talkToUs: "Talk to Us",
    workingHours: "Monday – Friday, 09:00 – 18:00",
    connectTitle: "Connect",
    quickSupportTitle: "Quick Support",
    quickSupportDesc: "For technical emergencies, use the direct line.",
    callNow: "Call Now",
    formTitle: "Send a Message",
    privacyNote: "Please write to us only after reviewing our",
    privacyLink: "privacy policy",
    labelName: "Full Name *",
    labelEmail: "Email *",
    labelPhone: "Phone *",
    labelSubject: "Subject *",
    labelMessage: "Message *",
    placeholderName: "John Smith",
    placeholderEmail: "john@example.com",
    placeholderMessage: "Please detail your request here...",
    subjectPlaceholder: "Choose a subject...",
    subjectConsultanta: "Platform Inquiries",
    subjectTehnic: "Technical App Support",
    subjectParteneriat: "B2B Partnerships",
    subjectEveniment: "Event Registration",
    subjectAnonimizare: "Document Anonymization",
    subjectAltele: "Other",
    sending: "Sending...",
    sendBtn: "Send Message",
    successTitle: "Message Sent!",
    successDesc: "Thank you for reaching out. Our team has received your message and will respond as soon as possible.",
    sendAnother: "Send another message",
    errorFields: "Please complete the following required fields:",
    errorCaptcha: "Please verify that you are not a robot.",
    errorGeneric: "An error occurred. Please try again.",
    errorSend: "Error sending the message.",
    fieldName: "Full Name",
    fieldEmail: "Email",
    fieldPhone: "Phone",
    fieldSubject: "Subject",
    fieldMessage: "Message"
  },
  fr: {
    seoTitle: "Contact - Legea Aplicată | Support Technique & Partenariats",
    seoDesc: "Contactez l'équipe Legea Aplicată pour le support technique, les demandes de compte ou les partenariats.",
    pageTitle: "Entrons en Contact",
    pageSubtitle: "Avez-vous des questions sur la plateforme ou ses fonctionnalités ? Notre équipe de support est prête à vous aider.",
    talkToUs: "Discutez avec nous",
    workingHours: "Lundi – Vendredi, 09h00 – 18h00",
    connectTitle: "Se connecter",
    quickSupportTitle: "Support Rapide",
    quickSupportDesc: "Pour les urgences techniques, utilisez la ligne directe.",
    callNow: "Appeler maintenant",
    formTitle: "Envoyer un message",
    privacyNote: "Veuillez nous écrire uniquement après avoir consulté notre",
    privacyLink: "politique de confidentialité",
    labelName: "Nom Complet *",
    labelEmail: "E-mail *",
    labelPhone: "Téléphone *",
    labelSubject: "Objet *",
    labelMessage: "Message *",
    placeholderName: "Jean Dupont",
    placeholderEmail: "jean@exemple.fr",
    placeholderMessage: "Veuillez détailler votre demande ici...",
    subjectPlaceholder: "Choisissez un objet...",
    subjectConsultanta: "Questions sur la Plateforme",
    subjectTehnic: "Support Technique Applicatif",
    subjectParteneriat: "Partenariats B2B",
    subjectEveniment: "Inscription à un Événement",
    subjectAnonimizare: "Anonymisation de Document",
    subjectAltele: "Autre",
    sending: "Envoi en cours...",
    sendBtn: "Envoyer le Message",
    successTitle: "Message Envoyé !",
    successDesc: "Merci de nous avoir contactés. Notre équipe a bien reçu votre message et vous répondra dans les plus brefs délais.",
    sendAnother: "Envoyer un autre message",
    errorFields: "Veuillez remplir les champs obligatoires suivants :",
    errorCaptcha: "Veuillez confirmer que vous n'êtes pas un robot.",
    errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
    errorSend: "Erreur lors de l'envoi du message.",
    fieldName: "Nom Complet",
    fieldEmail: "E-mail",
    fieldPhone: "Téléphone",
    fieldSubject: "Objet",
    fieldMessage: "Message"
  }
};

export default contactTranslations;
